import { render, staticRenderFns } from "./kafa-form-data.vue?vue&type=template&id=61cd0e9e&scoped=true&lang=pug"
import script from "./kafa-form-data.vue?vue&type=script&setup=true&lang=js"
export * from "./kafa-form-data.vue?vue&type=script&setup=true&lang=js"
import style0 from "./kafa-form-data.vue?vue&type=style&index=0&id=61cd0e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd0e9e",
  null
  
)

export default component.exports